import { render, staticRenderFns } from "./UserPicture.vue?vue&type=template&id=abbe7b0c&"
import script from "./UserPicture.vue?vue&type=script&lang=js&"
export * from "./UserPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports